const vaihingerForm = (function () {
	/** Private **/
	const theForm = document.querySelector('#vai_form');
	const theResponse = document.querySelector('#user_response');

	function showResponse(color,message){
		theResponse.style.color = color;
		theResponse.innerText = message;

		// Clean Form
		if(color==='green')
			 theForm.reset();

		// Show Message, hide after 5 seconds
		theResponse.classList.add('active');
		setTimeout(() => theResponse.classList.remove('active'),5000);
	}

	function submitForm(e) {
		e.preventDefault();

		// Building FormData
		const formData = {};
		Array.from(theForm.elements)
			.forEach(element => {
				if (element.name)
					formData[element.name] = element.value;
			});

		// Building Config Data
		const config = {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		};

		// Sending the Mail
		axios
			.post('/wp-json/vai/v1/sendForm',JSON.stringify(formData),config)
			.then(({data : response}) => {
				if(response.success)
					showResponse('green',response.message);
				else
					showResponse('red','Fehler beim Senden des Formulars, bitte versuchen Sie es später noch einmal.');
			})
			.catch(()=> showResponse('red','Fehler beim Senden des Formulars, bitte versuchen Sie es später noch einmal.'));
	}

	/** Public **/
	function setup() {
		theForm.addEventListener('submit', submitForm)
	}

	return setup;
})();